<footer class="mainFooter mainFooter-negative">
  <div class="mainFooter-top" *ngIf="mainFooterTop">
    <div class="container">
      <div class="mainFooter-top1">
        <a class="mainFooter-logo" routerLink="/" title="">
          <picture>
            <img class="color" src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL'"/>
            <img class="negative" src="assets/images/icons/logo-neg.svg" alt="'NOMBRE COMERCIAL'"/>
          </picture>
        </a>
        <div class="mainFooter-idiomas" *ngIf="menuIdiomas">
          <neo-menu-dropdown [elementos]="elementosIdioma"></neo-menu-dropdown>
        </div>
      </div>
      <div class="mainFooter-top2">
        <!--
        <div class="mainFooter-ubicaciones" *ngIf="mostrarUbicaciones">
          <div class="mainFooter-central">
            <div class="mainFooter-direccion" *ngIf="direccion">
              <div class="text-bold">{{'shared.dc_direccion' | transloco}}</div>
              <div class="text-light">
                <neo-span-inner-html [contenido]="direccion"></neo-span-inner-html>
              </div>
            </div>
            <div class="mainFooter-telefono" *ngIf="telefono">
              <!--              TODO: Revisar si hacer uso función Matrix DC_STRING_HELPER::telefonoTexto()
              <a class="text-underline" href="tel:{{telefono}}" title="" target="_blank">{{telefono}}</a>
            </div>
            <div class="mainFooter-email" *ngIf="email">
              <a class="text-underline" href="mailto:{{email}}" title="" target="_blank">{{email}}</a>
            </div>
          </div>
          <!-- TODO: Revisar, en matrix es un bloque editable
          <div class="mainFooter-secundarias" *ngIf="direccionesAdicionales">
            <div class="mainFooter-direccion" *ngFor="let direccionAdicional of direccionesAdicionales">
              <div class="text-bold">{{direccionAdicional.titulo}}</div>
              <div class="text-light">
                {{direccionAdicional.direccion}}
                <br/>{{direccionAdicional.poblacion}}
                <br/>{{direccionAdicional.pais}}
              </div>
            </div>
          </div>
        </div>
        -->
        <div class="mainFooter-menu" *ngIf="menuFooter">
          <neo-menu-dropdown [elementos]="elementosMenu.slice(0, mathCeil(elementosMenu.length / 2))"></neo-menu-dropdown>
          <neo-menu-dropdown [elementos]="elementosMenu.slice(mathCeil(elementosMenu.length / 2), elementosMenu.length )">
          </neo-menu-dropdown>
        </div>
        <!--
        <div class="mainFooter-social" *ngIf="menuSocial">
          <neo-menu-social></neo-menu-social>
        </div>
        -->
        <div class="mainFooter-pets">
          <picture>
            <img src="assets/images/icons/pet_friendly-neg.png" alt=""/>
          </picture>
        </div>
      </div>
    </div>
  </div>
  <div class="mainFooter-bottom">
    <div class="container">
      <div class="row">
        <div class="mainFooter-copyright col-lg-3">
          {{nombreComercial}}.
          {{fechaActual | date: 'yyyy'}}
        </div>
        <div class="mainFooter-legal col-lg-6 col-sm-9">
          <div>
            <a routerLink="aviso-legal" title="">{{'legal' | transloco}}</a>
          </div>
          <div>
            <a href="cookies" title="">{{'cookies' | transloco}}</a>
          </div>
          <div *ngIf="preferenciasService.get('matrix_cookiebot')">
            <a href="javascript:CookieConsent.renew();CookieDeclaration.SetUserStatusLabel();" title="" rel="nofollow">{{'comun_footer-gestion-cookies' | transloco}}</a>
          </div>
        </div>
        <div class="mainFooter-duacode col-lg-3 col-sm-3">
          <a href="https://www.duacode.com" title="<?=lang('comun_footer-duacode')?> Duacode" target="_blank" rel="nofollow noopener noreferer">
            Diseñado por
            <img src="assets/images/iconos/duacode.svg" alt="duacode - software y diseño. mezclado, no agitado" />
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
